
var megaMenuOpen = false;

prepThemeMegaMenu = () => {
  const header = document.getElementById('header');
  const nav = document.querySelector('.cp-theme-mega-nav');
  const backdrop = document.querySelector('.cp-theme-mega-backdrop');

  if (!header || !nav || nav.dataset.themeMegaBound === 'true') return;

  nav.dataset.themeMegaBound = 'true';

  const items = Array.from(nav.querySelectorAll('[data-cp-theme-mega-item]'));
  const panels = items.map((item) => item.querySelector('.cp-theme-mega-panel'));
  let activeItem = null;
  let activePanel = null;
  let openTimeout = null;
  let closeTimeout = null;

  const getItems = () => Array.from(nav.querySelectorAll('[data-cp-theme-mega-item]'));
  const getPanels = () => getItems().map((item) => item.querySelector('.cp-theme-mega-panel')).filter(Boolean);
  const setItemExpanded = (item, expanded) => {
    const trigger = item.querySelector('.cp-theme-mega-trigger');
    if (!trigger || !trigger.hasAttribute('aria-expanded')) return;

    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  };

  const clearOpenTimeout = () => {
    if (openTimeout) {
      clearTimeout(openTimeout);
      openTimeout = null;
    }
  };

  const clearCloseTimeout = () => {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
  };

  const closeThemeMegaMenu = () => {
    clearOpenTimeout();
    clearCloseTimeout();

    getItems().forEach((item) => {
      item.classList.remove('active');
      setItemExpanded(item, false);
    });
    getPanels().forEach((panel) => {
      if (!panel) return;
      panel.classList.remove('is-open');
    });

    if (backdrop) backdrop.classList.remove('is-open');

    activeItem = null;
    activePanel = null;
    megaMenuOpen = false;
  };

  const scheduleThemeMegaClose = () => {
    clearCloseTimeout();
    closeTimeout = setTimeout(() => {
      closeThemeMegaMenu();
    }, 1000);
  };

  const openThemeMegaMenu = (item) => {
    const panel = item.querySelector('.cp-theme-mega-panel');

    clearCloseTimeout();

    if (!panel) {
      closeThemeMegaMenu();
      return;
    }

    if (activeItem === item && activePanel && activePanel.classList.contains('is-open')) {
      setItemExpanded(item, true);
      return;
    }

    getItems().forEach((navItem) => {
      navItem.classList.remove('active');
      setItemExpanded(navItem, false);
    });
    getPanels().forEach((navPanel) => {
      if (!navPanel || navPanel === panel) return;
      navPanel.classList.remove('is-open');
    });

    item.classList.add('active');
    setItemExpanded(item, true);
    panel.classList.add('is-open');

    if (backdrop) backdrop.classList.add('is-open');

    activeItem = item;
    activePanel = panel;
    megaMenuOpen = true;
  };

  items.forEach((item) => {
    const panel = item.querySelector('.cp-theme-mega-panel');
    const trigger = item.querySelector('.cp-theme-mega-trigger');
    const closeTrigger = item.querySelector('.cp-theme-mega-panel .close');

    item.addEventListener('mouseenter', () => {
      clearOpenTimeout();
      clearCloseTimeout();
      openTimeout = setTimeout(() => {
        openThemeMegaMenu(item);
      }, 100);
    });

    item.addEventListener('mouseleave', () => {
      clearOpenTimeout();
      scheduleThemeMegaClose();
    });

    if (trigger) {
      trigger.addEventListener('focus', () => {
        openThemeMegaMenu(item);
      });
    }

    if (closeTrigger) {
      closeTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeThemeMegaMenu();
      });
    }

    if (panel) {
      panel.addEventListener('mouseenter', clearCloseTimeout);
      panel.addEventListener('mouseleave', scheduleThemeMegaClose);

      panel.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  });

  nav.addEventListener('mouseover', (event) => {
    const item = event.target.closest('[data-cp-theme-mega-item]');
    if (!item || !nav.contains(item)) return;

    clearOpenTimeout();
    clearCloseTimeout();
    openTimeout = setTimeout(() => {
      openThemeMegaMenu(item);
    }, 100);
  });

  nav.addEventListener('mouseout', (event) => {
    clearOpenTimeout();
    if (!event.relatedTarget || !nav.contains(event.relatedTarget)) {
      scheduleThemeMegaClose();
    }
  });

  nav.addEventListener('focusin', (event) => {
    const item = event.target.closest('[data-cp-theme-mega-item]');
    if (!item || !nav.contains(item)) return;

    openThemeMegaMenu(item);
  });

  if (backdrop) {
    backdrop.addEventListener('click', closeThemeMegaMenu);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeThemeMegaMenu();
  });

  document.addEventListener('click', (event) => {
    if (!activePanel) return;
    if (nav.contains(event.target) || activePanel.contains(event.target)) return;
    closeThemeMegaMenu();
  });

};

prepMegaMenu = () => {

  const megaMenuWrapper = document.querySelector('.mega-menu-wrapper');
  const themeMegaNav = document.querySelector('.cp-theme-mega-nav');

  if (themeMegaNav) {
    prepThemeMegaMenu();
  }

  if (!megaMenuWrapper) return;

  const previewColumns = megaMenuWrapper.querySelectorAll('.preview-column');
  const previewColumnInners = megaMenuWrapper.querySelectorAll('.preview-column .inner');
  const backdrop = megaMenuWrapper.querySelector('.backdrop');
  let shiftTls = [];

  prepInfiniteMenuCols = () => {

    const windowWidth = getViewport().width;

    if (windowWidth > 767) {
      const wrapperHeight = previewColumns[0].offsetHeight;
      const headerHeight = windowWidth > 767 ? 80 : 70;

      for (let i = 0; i < previewColumns.length; i++) {
        let elParent = previewColumnInners[i].parentElement; // shift-container
        let shiftElBounds = elParent.getBoundingClientRect();
        let el = previewColumnInners[i];

        const colHeight = el.offsetHeight;
        let heightDiff = colHeight - wrapperHeight;
        const colClone = el.cloneNode(true);

        const shiftTL = new gsap.timeline({ paused: true });
        let resetAt;

        let resetTo;
        if (colHeight > wrapperHeight) {
          elParent.appendChild(colClone);
          resetAt = colHeight + heightDiff;
          resetTo = heightDiff;
        } else {

          let colCloneTwo = el.cloneNode(true);
          elParent.appendChild(colClone);
          elParent.appendChild(colCloneTwo);
        }

        let firstDur = Math.round((25 * (resetTo / resetAt)) * 1e4) / 1e4;
        let secondDur = (25 - firstDur);

        shiftTL
          .fromTo(elParent, firstDur, { y: -40 }, { y: -resetTo, ease: Linear.easeNone, force3D: true })
          .add('resetLabel')
          .fromTo(elParent, secondDur, { y: -resetTo }, {
            immediateRender: false, y: -resetAt, ease: Linear.easeNone, force3D: true, onComplete: () => {
              shiftTL.tweenFromTo('resetLabel', shiftTL.totalDuration());
            }
          });

        shiftTls.push(shiftTL);

        if (isMobile()) {
          el.addEventListener('mouseenter', (event) => {
            shiftTL.pause();
          }, false);
          el.addEventListener('mouseleave', (event) => {
            shiftTL.play();
          }, false);
        }
      }
    }
  };

  prepInfiniteMenuCols();

  let header = document.getElementById('header');

  const primaryHoverTargets = header.querySelectorAll('.left li a:not(.nav)');
  const primaryCloseTriggers = megaMenuWrapper.querySelectorAll('.panel.one .close, .backdrop');
  const secondaryCloseTriggers = megaMenuWrapper.querySelectorAll('.panel.two .close');
  const secondaryHoverTargets = megaMenuWrapper.querySelectorAll('.secondary-hovers li');
  const megaMenus = megaMenuWrapper.querySelectorAll('.mega-menu');
  const primaryPanels = megaMenuWrapper.querySelectorAll('.panel.one');
  const secondaryPanels = megaMenuWrapper.querySelectorAll('.panel.two');
  const secondaryPanelWrappers = megaMenuWrapper.querySelectorAll('.secondary-panels');
  const tertiaryHoverTargets = megaMenuWrapper.querySelectorAll('.tertiary-hovers li');
  const tertiaryContent = megaMenuWrapper.querySelectorAll('.tertiary-content');

  const getMegaMenuIndex = (trigger, fallbackIndex) => {
    const menuName = trigger.dataset ? trigger.dataset.megaMenu : null;

    if (menuName) {
      for (let menuIndex = 0; menuIndex < megaMenus.length; menuIndex++) {
        if (megaMenus[menuIndex].classList.contains(menuName)) {
          return menuIndex;
        }
      }
    }

    return fallbackIndex;
  };

  let prevPrimaryIdx = 99;
  let prevSecondaryIdx = 99;
  let prevTertiaryIdx = 99;
  let secondaryPanelOpen = false;
  let tertiaryPanelOpen = false;
  let primaryHoverTimeout

  gsap.set(secondaryPanels, { x: -120, autoAlpha: 0, pointerEvents: 'none' });
  gsap.set(megaMenus, { x: -120, autoAlpha: 0, pointerEvents: 'none' });

  megaMenus.forEach((el) => {
    el.addEventListener('click', () => {
      escMegaMenu();
    });
  });

  primaryPanels.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  secondaryPanelWrappers.forEach((el) => {
    el.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  // Add event listeners for links without mega menus (nav class links)
  const navLinks = header.querySelectorAll('.left li a.nav, .right li a.nav');
  navLinks.forEach((el) => {
    el.addEventListener('mouseenter', () => {
      if (megaMenuOpen) {
        escMegaMenu();
      }
    });
  });

  primaryHoverTargets.forEach((el, i) => {

    el.addEventListener("mouseout", () => {
      clearTimeout(primaryHoverTimeout)
    })

    el.addEventListener('mouseenter', () => {

      const megaMenuIdx = getMegaMenuIndex(el, i);

      console.log(prevPrimaryIdx, megaMenuIdx)

      if (!megaMenus[megaMenuIdx]) {
        escMegaMenu();
        return;
      }

      if (prevPrimaryIdx === megaMenuIdx) { return; }

      if (hasClass(el, "no-hover")) {

        escMegaMenu();

        return;
      }

      // Set underline
      primaryHoverTargets.forEach(target => {
        target.classList.remove("active");
      });

      el.classList.add("active");

      // setTimeout to do the other stuff
      // save timeoutID locally
      //on mouseout, clear timeout id
      primaryHoverTimeout = setTimeout(() => {
        gsap.to(backdrop, .4, { autoAlpha: 1, ease: Sine.easeInOut, force3D: true });

        if (prevPrimaryIdx !== 99) {
          gsap.set(megaMenus, { autoAlpha: 0, pointerEvents: 'none' });
        }

        prevPrimaryIdx = megaMenuIdx;

        if (prevSecondaryIdx !== 99) {
          secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
          gsap.set(secondaryPanels, { x: -100, autoAlpha: 0, pointerEvents: 'none' });
          secondaryPanelOpen = false;
          prevSecondaryIdx = 99;
        }

        if (prevTertiaryIdx !== 99) {
          tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
          gsap.set(tertiaryContent, { autoAlpha: 0, pointerEvents: "none" });
          tertiaryPanelOpen = false;
          prevTertiaryIdx = 99;
        }

        if (megaMenuOpen) {
          gsap.set(megaMenus[megaMenuIdx], { x: 0, autoAlpha: 1, pointerEvents: 'all' });
        } else {
          megaMenuOpen = true;
          gsap.fromTo(megaMenus[megaMenuIdx], 0.7, { autoAlpha: 0, pointerEvents: 'none' }, { autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut, force3D: true });
          gsap.fromTo(megaMenus[megaMenuIdx], 1.05, { x: -100 }, { x: 0, ease: Expo.easeOut, force3D: true });
        }
      }, 100)
    });
  });

  secondaryHoverTargets.forEach((el, i) => {


    el.addEventListener('mouseenter', () => {
      console.log("prevSecondaryIdx", prevSecondaryIdx);
      console.log("cnt", i);

      if (prevSecondaryIdx === i) { return; }

      if (prevSecondaryIdx !== 99) {
        secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
        gsap.set(secondaryPanels[prevSecondaryIdx], { autoAlpha: 0, x: -70, pointerEvents: 'none' });
      }

      prevSecondaryIdx = i;

      if (prevTertiaryIdx !== 99) {
        tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
        gsap.set(tertiaryContent, { autoAlpha: 0, pointerEvents: "none" });
        tertiaryPanelOpen = false;
        prevTertiaryIdx = 99;
      }

      el.classList.add('active');

      if (!secondaryPanelOpen) {
        secondaryPanelOpen = true;
        gsap.fromTo(secondaryPanels[i], 0.6, { autoAlpha: 0, pointerEvents: 'none' }, { autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut, force3D: true });
        gsap.fromTo(secondaryPanels[i], 1, { x: -100 }, { x: 0, ease: Expo.easeOut, force3D: true });
      } else {
        gsap.set(secondaryPanels[i], { autoAlpha: 1, x: 0, pointerEvents: 'all' });
      }
    });
  });

  tertiaryHoverTargets.forEach((el, i) => {
    el.addEventListener('mouseenter', () => {
      if (prevTertiaryIdx === i) { return; }
      if (prevTertiaryIdx !== 99) {
        tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
        gsap.set(tertiaryContent[prevTertiaryIdx], { autoAlpha: 0, pointerEvents: "none" });

        if (shiftTls[prevTertiaryIdx]) {
          shiftTls[prevTertiaryIdx].pause();
        }
      }
      prevTertiaryIdx = i;
      if (!tertiaryPanelOpen) {
        tertiaryPanelOpen = true;
        if (shiftTls[i]) {
          shiftTls[i].play();
        }
        gsap.fromTo(previewColumns[i], 1.1, { autoAlpha: 0, pointerEvents: 'none' }, { y: 0, autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut });
      } else {
        if (shiftTls[i]) {
          shiftTls[i].play();
        }
        gsap.set(tertiaryContent[i], { autoAlpha: 1, y: 0, pointerEvents: "all" });
      }
      el.classList.add('active');
    });

    el.addEventListener('mouseleave', () => {

    });
  });

  primaryCloseTriggers.forEach((el, i) => {
    el.addEventListener('click', () => {
      gsap.to(backdrop, .4, { autoAlpha: 0, ease: Sine.easeOut, force3D: true });
      gsap.to(megaMenus, 1.05, { x: -100, autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true });
      if (prevSecondaryIdx !== 99) {
        secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
        gsap.to(secondaryPanels, 1.05, { x: -100, autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true });
      }
      if (prevTertiaryIdx !== 99) {
        tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
        gsap.set(tertiaryContent[prevTertiaryIdx], { autoAlpha: 0, pointerEvents: "none" });
        if (shiftTls[prevTertiaryIdx]) {
          shiftTls[prevTertiaryIdx].pause();
        }
      }
      megaMenuOpen = false;
      secondaryPanelOpen = false;
      tertiaryPanelOpen = false;
      prevPrimaryIdx = 99;
      prevSecondaryIdx = 99;
      prevTertiaryIdx = 99;
    });
  });

  secondaryCloseTriggers.forEach((el, i) => {
    el.addEventListener('click', () => {
      if (prevTertiaryIdx !== 99 && shiftTls[prevTertiaryIdx]) {
        gsap.delayedCall(0.37, () => {
          if (shiftTls[prevTertiaryIdx]) {
            shiftTls[prevTertiaryIdx].pause();
          }
        });
      }
      gsap.to(secondaryPanels, 1.05, {
        x: -100, autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true, onComplete: () => {
          if (prevTertiaryIdx !== 99) {
            tertiaryHoverTargets[prevTertiaryIdx].classList.remove('active');
            gsap.set(tertiaryContent, { autoAlpha: 0, pointerEvents: "none" });
          }
        }
      });
      if (prevSecondaryIdx !== 99) {
        secondaryHoverTargets[prevSecondaryIdx].classList.remove('active');
      }
      secondaryPanelOpen = false;
      tertiaryPanelOpen = false;
      prevSecondaryIdx = 99;

      // Remove underline
      primaryHoverTargets.forEach(target => {
        target.classList.remove("active");
      })
    });
  });

  escMegaMenu = () => {

    if (secondaryPanelOpen) {
      secondaryCloseTriggers[prevSecondaryIdx].click();
    }

    if (megaMenuOpen) {
      gsap.to(backdrop, 0.4, { autoAlpha: 0, ease: Sine.easeOut, force3D: true });

      if (primaryCloseTriggers[prevPrimaryIdx]) primaryCloseTriggers[prevPrimaryIdx].click();
    }
  };

  reverseMegaMenu = () => {
    primaryCloseTriggers[prevPrimaryIdx].click();
  };

  // Add scroll event listener to close mega menu when scrolling
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (megaMenuOpen) {
      // Clear any existing timeout to debounce the scroll event
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        escMegaMenu();
      }, 50); // Small delay to avoid closing on minor scroll movements
    }
  });
};
